import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';

import SelectFile from './sessionJoinDialogFiles.component';

const styles = () => ({
  icon: {
    textAlign: 'center',
    paddingTop: '35px',
  },
  block: {
    padding: '10px 20px',
  },
});

class SelectFilePairComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange(this.props.index, { [event.target.name]: event.target.value });
  }

  render() {
    const {
      join,
      files,
      filteredFiles,
      classes,
    } = this.props;
    return (
      <Grid className={classes.block} container>
        <Grid md={5} item>
          <SelectFile
            name="sourceFile"
            shownName="Source file"
            onChange={this.handleChange}
            files={_.pickBy(files, file => file.id !== join.targetFile)}
            filteredFiles={_.pickBy(filteredFiles, file => file.id !== join.targetFile)}
            value={join.sourceFile}
          />
        </Grid>
        <Grid md={2} className={classes.icon} item>
          <Icon>add</Icon>
        </Grid>
        <Grid md={5} item>
          <SelectFile
            name="targetFile"
            shownName="Target file"
            onChange={this.handleChange}
            files={_.pickBy(files, file => file.id !== join.sourceFile)}
            value={join.targetFile}
          />
        </Grid>
      </Grid>
    );
  };
}

SelectFilePairComponent.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  join: PropTypes.shape({
    sourceFile: PropTypes.string,
    targetFile: PropTypes.string,
    sourceField: PropTypes.string,
    targetField: PropTypes.string,
  }).isRequired,
  files: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
  }).isRequired,
  filteredFiles: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
  }).isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(SelectFilePairComponent);
